<template>
  <div class="container" v-bind="loading()">
    <div class="row">
      <div class="col col s12 m12 xl12">
        <div class="card">
          <div class="card-image">
            <img src="../../assets/catering/infoCatering.jpg">
            <a
              class="btn-floating halfway-fab waves-effect waves-light red darken-4 activator pulse"
            >
              <i class="material-icons right">more_vert</i>
            </a>
          </div>
          <div class="card-content">
            <ul class="tabs">
              <li class="tab col s6 m6 l6 xl6">
                <a href="#ListMenuToday" class="active">
                  <i class="material-icons tab-icon-material-icon">restaurant</i>
                  <span class="tab-icon-material-text">Menu del Día</span>
                </a>
              </li>
              <li class="tab col s6 m6 l6 xl6">
                <a href="#ListMenuWeek">
                  <i class="material-icons tab-icon-material-icon">search</i>
                  <span class="tab-icon-material tab-icon-material-text">Buscar Menu</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="card-reveal">
            <span class="card-title red-text text-darken-4">
              Something Special
              <i class="material-icons right">restaurant_menu</i>
            </span>
            
            <strong class="red-text text-darken-4">Catering:</strong> {{cateringId}}<br>
            <strong  class="red-text text-darken-4">Contrato:</strong>2019SERVI{{cateringId}}<br><br>
            Almuerzos empacados cómodamente para eventos que no necesitan mucho protocolo. Catering para tus eventos. Refrigerios y más. Listos para tus juntas. Servicios: Servicios para Catering, Refrigerios empresariales, Desayunos corporativos.
            <br><br>
            <a onclick="M.toast({html: 'Generando Llamada'})" class="btn-small red darken-4 white-text">
              <i class="material-icons left">contact_phone</i>Contactar al Administrador!</a>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <ListMenuToday v-bind:cateringId="cateringId"></ListMenuToday>
      <ListMenuWeek></ListMenuWeek>
    </div>
  </div>
</template>
  
<script>
import ListMenuWeek from "../menu/ListMenuWeek";
import ListMenuToday from "../menu/ListMenuToday";
export default {
  name: "InfoCatering",
  data() {
    return {
      cateringId: String
    };
  },
  components: {
    ListMenuWeek,
    ListMenuToday
  },
  methods: {
    loading() {
      if (
        this.$route.params.cateringId === undefined ||
        this.$route.params.cateringId === null
      ) {
        this.cateringId = 0;
      } else {
        this.cateringId = this.$route.params.cateringId;
      }

      $(document).ready(function() {
        $(".collapsible").collapsible();
        $(".tabs").tabs();
      });
    }
  }
};
</script>

<style scoped lang="css">
.container {
  width: 100% !important;
}
.row {
  margin-bottom: 0px !important;
}
.row .col {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 0 0 0 !important;
  min-height: 1px;
}
.card {
  margin: 0 0 0 0 !important;
}
.card .card-content {
  padding: 0px !important;
}
.tab-icon-material-icon {
  position: absolute;
  top: 25%;
}

.tab-icon-material-text {
  margin: 0px 0px 0px 30px;
}

.tabs .tab a:hover,
.tabs .tab a.active {
  background-color: transparent;
  color: #ffffff !important;
  background-color: #f05545 !important;
}
.tabs .tab a {
  background-color: transparent;
  color: #f05545 !important;
  background-color: #f4f4f5 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/catering/InfoCatering.vue